import { useVehicleData } from 'Context/VehicleContext/VehicleDataContext';
import type { VehicleMOT } from 'Pages/vehicles/helpers/vehicle.schema';

export const useVehicleMot = (): VehicleMOT => {
	const { mot } = useVehicleData();

	return mot;
};
